export default function HowItWorksSection() {
  const steps = [
    {
      step: '01',
      icon: 'ri-user-add-line',
      title: '注册账号',
      desc: '手机号快速注册，完成实名认证，开启购彩之旅。',
    },
    {
      step: '02',
      icon: 'ri-file-list-line',
      title: '选择玩法',
      desc: '浏览各类彩票玩法，选择心仪号码或机选号码进行投注。',
    },
    {
      step: '03',
      icon: 'ri-trophy-line',
      title: '等待开奖',
      desc: '关注开奖时间，中奖后奖金自动到账，提现秒到银行卡。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            三步轻松购彩
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            简单快捷的操作流程，让购彩变得轻松愉快
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="text-center relative">
              <div className="w-20 h-20 mx-auto mb-5 rounded-full bg-primary-500 flex items-center justify-center relative">
                <i className={`${step.icon} text-2xl text-white`}></i>
                <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent-500 text-white text-xs font-bold flex items-center justify-center">
                  {step.step}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed max-w-xs mx-auto">
                {step.desc}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[calc(50%+3rem)] w-[calc(100%-6rem)]">
                  <div className="border-t-2 border-dashed border-primary-200"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}